'use strict';

import {EwSiteApp} from "../../app/ewsiteapp.js";

import {KonkursaiListSiteCtrl} from "./konkursailistsitectrl.js";
EwSiteApp.controller('KonkursaiListSiteCtrl', ["$scope", "$http", "$filter", "$timeout", "$locale", "jsDataService", KonkursaiListSiteCtrl]);

import {KonkursaiFormCtrl} from "@js/modules/konkursai/konkursaiform";
EwSiteApp.controller('KonkursaiFormCtrl', ["$scope", "$http", "$filter", "$timeout", "$locale", "jsDataService", KonkursaiFormCtrl]);
